import { createRequest, createSuccess, createFailure } from '../helpers';
import constants from './constants';

export const branchesRequest = createRequest(constants.branches);
export const branchesSuccess = createSuccess(constants.branches);
export const branchesFailure = createFailure(constants.branches);

export const branchRequest = createRequest(constants.branch);
export const branchSuccess = createSuccess(constants.branch);
export const branchFailure = createFailure(constants.branch);

export const branchOptionsRequest = createRequest(constants.branchOptions);
export const branchOptionsSuccess = createSuccess(constants.branchOptions);
export const branchOptionsFailure = createFailure(constants.branchOptions);

export const createBranchRequest = createRequest(constants.createBranch);
export const createBranchSuccess = createSuccess(constants.createBranch);
export const createBranchFailure = createFailure(constants.createBranch);

export const updateBranchRequest = createRequest(constants.updateBranch);
export const updateBranchSuccess = createSuccess(constants.updateBranch);
export const updateBranchFailure = createFailure(constants.updateBranch);

export const updateBranchStatusRequest = createRequest(constants.updateBranchStatus);
export const updateBranchStatusSuccess = createSuccess(constants.updateBranchStatus);
export const updateBranchStatusFailure = createFailure(constants.updateBranchStatus);

export const requestBranches = branchesRequest;
export const requestBranch = branchRequest;
export const requestBranchOptions = branchOptionsRequest;
export const createBranch = createBranchRequest;
export const updateBranch = updateBranchRequest;
export const updateBranchStatus = updateBranchStatusRequest;
